import type { GridApiPremium, GridBasicGroupNode } from "@mui/x-data-grid-premium";
import type { RefObject } from "react";
import { getRowNode } from "@entrilia/shared/utilities/dataGridApiHelper.ts";
import type { ReportField, ValueCell } from "../../../../../../../../api/types/svTypes.ts";
import { isDimension } from "../../../../utilities/fieldsHelper.ts";

export function getGroupKeys(
  rowNode: GridBasicGroupNode,
  fields: ReportField[],
  apiRef: RefObject<GridApiPremium | null>
) {
  const filters: Record<string, Partial<ValueCell>> = {};
  if (rowNode.groupingKey !== null) {
    const field = fields.find((f) => f.config.guid === rowNode.groupingField);
    if (!field) {
      return {};
    }

    const value = getKey(field, rowNode.groupingKey.toString());
    filters[field.meta.name] = {
      value:
        value === "" //This value, an empty string in this case, is a default grouping key for a null cell value that groupingValueGetter uses.
          ? null
          : value,
    };
  }

  if (rowNode.parent !== null) {
    const parentNode = getRowNode(apiRef, rowNode.parent);
    if (parentNode !== null && parentNode.type === "group") {
      const parentKeys = getGroupKeys(parentNode, fields, apiRef);
      Object.assign(filters, parentKeys);
    }
  }

  return filters;
}

function getKey(field: ReportField, key: string): string {
  if (!isDimension(field)) {
    return key;
  }

  const displayValues = field.config.displayValues || field.meta.displayValues;
  if (displayValues === undefined) {
    return key;
  }

  const fieldKey = displayValues[0];
  if (fieldKey === undefined) {
    return key;
  }

  const item = field.meta.dictionary.find((pair) => pair[fieldKey] === key);
  if (item === undefined || field.meta.keyFieldName === undefined) {
    return key;
  }

  return (item[field.meta.keyFieldName] as string) || key;
}
